// A clean, centered "no data" placeholder shown when an API returns nothing
// (or fails and falls back to empty). Consistent look across all charts/tables.
//
//   <EmptyState message="No footfall data available" />
//   <EmptyState title="No Data Available" message="Nothing for the selected date" />
export default function EmptyState({
  title,
  message = 'No data available',
  compact = false,
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 8,
        padding: compact ? '24px 16px' : '40px 20px',
        color: 'var(--g400)',
      }}
    >
      <svg width={compact ? 28 : 40} height={compact ? 28 : 40} viewBox="0 0 24 24"
        fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"
        style={{ color: 'var(--g300)' }}>
        <path d="M3 15a4 4 0 0 0 4 4h11a3 3 0 0 0 .5-5.96A5 5 0 0 0 9 8.5"/>
        <path d="M3 15a4 4 0 0 1 2.5-3.7"/>
        <line x1="3" y1="3" x2="21" y2="21"/>
      </svg>
      {title && (
        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--g700)' }}>{title}</div>
      )}
      <div style={{ fontSize: 12 }}>{message}</div>
    </div>
  );
}
